// Put utility functions here
const formQuestionId = (schemaId, storyId) => `${schemaId}:${storyId}`;

export default formQuestionId;
